import React, { useEffect } from "react";
import { useAuth } from "../../hooks/useAuth";
import { useContent } from "../../hooks/useContent";

export default function Meetings() {
    const { userInfo } = useAuth();
    const { setPageHeading } = useContent();
    const userEmail = userInfo?.email || "default";

    const meetingUrl = `https://cloudfishmedical.com/meetings/${encodeURIComponent(userEmail)}?appName=veekrypt`;

    useEffect(() => {
        setPageHeading("Secure Web Conference");
    }, [])

    return (
        <div style={{ height: "100vh" }}>
            <iframe
                src={meetingUrl}
                style={{ width: "100%", height: "100%", border: "none" }}
                title="Web Conference"
            ></iframe>
        </div>
    );
}
